import Marquee from "react-fast-marquee";
import { Reveal, Overline } from "./Reveal";
import { Logo } from "./Logo";

const keywords = [
  "Impresa",
  "Innovazione",
  "Formazione",
  "Territorio Salentino",
  "Nuove Generazioni",
  "Valore Condiviso",
];

export const Credibility = () => (
  <section id="chi-siamo" className="relative overflow-hidden bg-[#0E1A4A] py-24 sm:py-32" data-testid="credibility-section">
    {/* Big editorial marquee */}
    <div className="mb-14 border-y border-white/10 py-8">
      <Marquee speed={30} gradient={false} autoFill>
        <span className="mx-8 font-display text-6xl font-black uppercase text-stroke-light sm:text-8xl">
          Non cercare lavoro, crealo.
        </span>
        <span className="mx-8 font-display text-6xl font-black uppercase text-[#C9A227] sm:text-8xl">
          Non cercare lavoro, crealo.
        </span>
      </Marquee>
    </div>

    {/* Keyword strip */}
    <div className="mb-20">
      <Marquee speed={22} direction="right" gradient={false} autoFill>
        {keywords.map((k) => (
          <span key={k} className="mx-6 inline-flex items-center gap-6 font-body text-sm uppercase tracking-overline text-white/50">
            {k}
            <span className="h-1.5 w-1.5 rounded-full bg-[#C9A227]" />
          </span>
        ))}
      </Marquee>
    </div>

    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <Overline className="text-[#C9A227]">Chi siamo</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6">
              <Logo variant="light" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-xl font-display text-2xl font-extrabold leading-snug text-white sm:text-3xl">
              &ldquo;Custodiamo il seme di un sogno comune.&rdquo;
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-white/75">
              La <strong className="text-white">Fondazione Semi d&rsquo;Impresa &ldquo;Luca Delle Donne&rdquo;</strong>{" "}
              Impresa Sociale ETS nasce per diffondere la cultura d&rsquo;impresa,
              sostenere la formazione dei giovani, valorizzare il talento e promuovere
              innovazione e responsabilità sociale sul territorio salentino.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-5 max-w-xl font-body text-sm leading-relaxed text-white/55">
              Un ecosistema che unisce impresa, istituzioni e comunità attorno a un
              obiettivo: far crescere nuove imprese reali.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal delay={0.15}>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-10 backdrop-blur-sm">
              <p className="font-display text-3xl font-black leading-tight text-white sm:text-4xl">
                &ldquo;Non cercare lavoro,{" "}
                <span className="text-[#C9A227]">crealo.&rdquo;</span>
              </p>
              <p className="mt-4 font-body text-sm text-white/60">
                Il manifesto di chi sceglie di costruire, non di aspettare.
              </p>

              {/* Partner logos */}
              <div className="mt-10 border-t border-white/10 pt-8">
                <p className="font-body text-[11px] uppercase tracking-overline text-[#C9A227]">
                  Con il sostegno di
                </p>
                <div className="mt-5 grid grid-cols-2 gap-5">
                  <div className="flex items-center justify-center rounded-xl bg-white p-5">
                    <img
                      src="/brand/confindustria-lecce.png"
                      alt="Confindustria Lecce"
                      className="h-14 w-auto object-contain sm:h-16"
                      data-testid="partner-confindustria-logo"
                    />
                  </div>
                  <div className="flex items-center justify-center rounded-xl bg-white p-5">
                    <img
                      src="/brand/ance-lecce.png"
                      alt="ANCE Lecce"
                      className="h-10 w-auto object-contain sm:h-12"
                      data-testid="partner-ance-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
